module.exports = __webpack_public_path__ + "img/daily-tournament-bg_1248.520e52a3.png";